export const coverageLabels = {
  AVAILABLE: "Documents available",
  PARTIAL: "Partial document coverage",
  PROCESSING: "Documents processing",
  ACCESS_REQUIRED: "Document access required",
  NOT_AVAILABLE: "Documents not available",
  FAILED: "Document processing needs attention",
};

export const statusLabels = {
  not_ready: "Not ready",
  up_to_date: "Up to date",
  processing: "Processing",
  waiting: "Waiting",
  needs_attention: "Needs attention",
};

export const ppaPresentation = (data) => {
  const intelligence = data?.status?.status;
  const state = intelligence?.status;
  const coverageState = data?.graph?.documentCoverage;

  return {
    available: Boolean(data?.graph?.available),
    coverage: coverageLabels[coverageState] || "Coverage unavailable",
    status: statusLabels[state] || "Status unavailable",
    needsAttention:
      state === "needs_attention" ||
      Boolean(intelligence?.reviewRequired) ||
      coverageState === "FAILED" ||
      coverageState === "ACCESS_REQUIRED",
    accessRequired: coverageState === "ACCESS_REQUIRED",
    busy: Boolean(intelligence?.busy),
    refreshAvailable: Boolean(intelligence?.refreshAvailable),
    reviewRequired: Boolean(intelligence?.reviewRequired),
    terminal: Boolean(intelligence?.terminal),
    graphVersion: data?.graph?.graphVersion ?? intelligence?.graphVersion ?? null,
    generatedAt: data?.graph?.generatedAt ?? intelligence?.graphUpdatedAt ?? null,
  };
};
